import swal from 'sweetalert2';
import get from 'lodash/get';
import { CustomerModel } from 'sales-flow-ui/domains/checkout/store/models';

import { CurrencyInfoModel } from './models';

export const state = {
  isWhitelabel: true,
  currencyInfo: new CurrencyInfoModel(),
  grecaptchaLoaded: false,
  headerCollapsed: false,
  scrollingUp: false,
  hideFixedHeader: true,
  domainConfig: null,
  search: null,
  searchApplied: false,
  customer: new CustomerModel(),
  collections: null,
  campaignErrorInfo: null,
};

export const mutations = {
  updatePaginatableCollection(state, { collectionObject, data, properties = '_embedded.items' }) {
    collectionObject.collection = [...collectionObject.collection, ...get(data, properties)];
    collectionObject.initialized = true;
    collectionObject.total = data.total_results;

    if (get(data, properties).length === collectionObject.limit) {
      collectionObject.page++;
      collectionObject.canLoad = true;
    } else {
      collectionObject.canLoad = false;
    }
  },

  resetPaginatableCollection(state, collectionObject) {
    collectionObject.collection = [];
    collectionObject.page = 0;
    collectionObject.total = 0;
    collectionObject.canLoad = true;
    collectionObject.initialized = false;
  },
};